import { ThemeProvider, createTheme } from "@mui/material";
import React from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import colors from "./config/colors";
import "./index.css";
import { persistor, store } from "./redux/store/store";
import Routing from "./routes/Routing";
const themeMuiTheme = createTheme(colors);

const App = () => {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={themeMuiTheme}>
            <ToastContainer
              position="bottom-right"
              hideProgressBar
              theme="colored"
            />
            <Routing />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
};

export default App;
